import React, { useState } from 'react';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import {
    Box,
    Typography,
} from '@mui/material';

const KeepOptions = () => {
    const [options, setOptions] = useState({
        toDos: true,
        assignees: false,
        completedToDos: true,
        allMembers: false,
        budgets: false,
        memberLimits: false,
        sameClient: true,
    });

    const toggle = (key) => {
        setOptions((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const toggleOption = (key) => {
        setOptions((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    return (
        <>
            <Box display="flex" alignItems="center" style={{ gap: '10px', lineHeight: '1' }} className="pb-10">
                <span><img src='./assets/images/app-activity/projects/icons/keep-icon.svg' className='img-fluid' alt='Keep Icon'/></span>
                <Typography style={{ fontSize: '16px', fontWeight: '600', color: '#0076FE', fontFamily:'Manrope' }}>Keep</Typography>
            </Box>


            <ul className="space-y-3">
                <li className="cursor-pointer" style={{ margin: '6px auto' }} onClick={() => toggleOption('toDos')}>
                    <input type="checkbox" checked={options.toDos} readOnly className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', lineHeight: '2', fontFamily:'Manrope' }}>To-Dos</span>
                </li>
                <ul style={{ marginLeft: '32px' }}>
                    <li className="cursor-pointer" style={{ margin: '6px auto' }} onClick={() => toggleOption('assignees')}>
                        <input type="checkbox" checked={options.assignees} readOnly className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', lineHeight: '2', fontFamily:'Manrope' }}>Assignees</span>
                    </li>
                    <li className="cursor-pointer" style={{ margin: '6px auto' }} onClick={() => toggleOption('completedToDos')}>
                        <input type="checkbox" checked={options.completedToDos} readOnly className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                        <span style={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', lineHeight: '2', fontFamily:'Manrope' }}>Completed To-Dos</span>
                    </li>
                </ul>

                <li className="cursor-pointer" style={{ margin: '6px auto' }} onClick={() => toggleOption('allMembers')}>
                    <input type="checkbox" checked={options.allMembers} readOnly className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', lineHeight: '2', fontFamily:'Manrope' }}>All Project Members</span>
                </li>
                <li className="cursor-pointer" style={{ margin: '6px auto' }} onClick={() => toggleOption('budgets')}>
                    <input type="checkbox" checked={options.budgets} readOnly className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', lineHeight: '2', fontFamily:'Manrope' }}>Budgets</span>
                </li>
                <li className="cursor-pointer" style={{ margin: '6px auto' }} onClick={() => toggleOption('memberLimits')}>
                    <input type="checkbox" checked={options.memberLimits} readOnly className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', lineHeight: '2', fontFamily:'Manrope' }}>Members Limits</span>
                </li>
                <li className="cursor-pointer" style={{ margin: '6px auto' }} onClick={() => toggleOption('sameClient')}>
                    <input type="checkbox" checked={options.sameClient} readOnly className="form-check-input" style={{ height: '20px', width: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', lineHeight: '2', fontFamily:'Manrope' }}>Belongs to same Client</span>
                </li>
            </ul>
        </>
    );
};

export default KeepOptions;
